<template>
    <div class="container" :style="{'min-height': height+'px'}">
        <div class="tle">
            <router-link to="/user"><span><i class="iconfont">&#xe703;</i>我的收藏</span></router-link>
        </div>
        <div class="content">
            <div class="tabs">
                <span class="tab-item" :class="[ type == '1'?'tab-avtive': '']" @click="addType('1')">文章</span>
                <span class="tab-item" :class="[ type == '3'?'tab-avtive': '']" @click="addType('3')">图片</span>
                <span class="tab-item" :class="[ type == '2'?'tab-avtive': '']" @click="addType('2')">视频</span>
            </div>
            <template v-if="favorite.length">
                <div class="card" v-for="item in favorite" :key="item.favorite_id">
                    <img class="bg" :src="item.img_path || item.logo_path | img_url_finish" @click="clickReview(item)">
                    <div class="icon" @click="cancalFavorite('',item.favorite_id,getList)">
                        <i class="iconfont">&#xe70f;</i>
                    </div>
                    <div class="text" @click="clickReview(item)">
                        <p>{{item.summary}}</p>
                        <p>{{item.create_time}}</p>
                    </div>
                </div>
            </template>
            <div v-else class="no-data">
                <img src="~mpic/no-favorite.png">
                <p>暂无数据</p>
            </div>
        </div>
        <div class="img-container" v-if="showImg" @click="showImg = false">
            <div class="num">{{active_idx}}/{{img_arr.length}}</div>
            <swiper ref="main-swiper" :options="swiperOption">
            　　<swiper-slide v-for="item,index in img_arr" :key="index">
                    <div class="swiper-item">
            　　　　    <img :src="item.img_path | img_url_finish">
                    </div>
            　　</swiper-slide>
            </swiper>
        </div>
        <div class="video-container" v-if="showVideo" @click="showVideo = false">
            <div class="video">
                <embed  :src="src"></embed>
            </div>
        </div>
    </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Swiper from 'swiper'

import { getFavorite } from '../../../service'
import { collect_mixin } from 'mjs/collect_mixin'

export default {
    mixins: [collect_mixin],
    data(){
        return {
            height:0,
            type: '1',
            favorite:[],
            showImg: false,
            active_idx: '1',
            showVideo:false,
            src:'',

            img_arr:[],
            swiperOption: {
                direction: 'horizontal',
                on:{
                    slideChange:() => {
                        this.active_idx = this.swiper.activeIndex + 1
                    }
                }
            },
        }
    },

    components:{
        swiper,
        swiperSlide
    },

    computed:{
        swiper(){
            return this.$refs['main-swiper'].swiper
        }
    },

    methods:{
        async getList(){
            let from = {
                user_key: this.user_key,
                type: this.type
            }
            let res = await getFavorite(from, (error) => {this.$Message.error('请求错误!')})
            this.favorite = res.favorite
        },
        addType(type){
            this.type = type
            this.getList()
        },
        clickReview(item) {// 0活动，1新闻，2视频，3影集，4专题
            console.log(item)
            switch (item.type) {
                case '1':
                    this.$router.push({name: 'ArticleDetail', params: {id: item.id}})
                break;
                case '2':
                    // this.$router.push({name: 'Video', params: {id: item.id}})
                    console.log(item.video_url)
                    this.$set(this.$data, 'src', item.video_url)
                    this.$set(this.$data, 'showVideo', true)
                break;
                case '3':
                    this.$set(this.$data, 'img_arr', item.article_imgs)
                    this.$set(this.$data, 'showImg', true)
                break;
            }
        },
    },
    created(){
        this.getList()
    },
    mounted() {
      this.height = document.documentElement.clientHeight + ''
    }
}
</script>

<style lang="stylus" scoped>
@import '../styles/common.styl'

.tabs
    padding: .4rem 0
    font-size: .26rem
    .tab-item
        display: inline-block
        margin-right: .14rem
        line-height: .22rem
        padding: .09rem .25rem
        background: #EEEEEE
        color: #666666
        border-radius: .21rem
    .tab-avtive
        background:#E12222
        color: #FFFFFF
.content
    .card
        position: relative
        min-height: 3.89rem
        .bg
            width: 100%
        .icon
            position:absolute
            top: .2rem
            right:.2rem
            width: .3rem
            height: .3rem
            background:#e12222
            z-index: 10
            border-radius: .04rem
            text-align: center
            line-height: .3rem
            i
                font-size: .2rem
                color: #ffffff
        .text
            position:absolute
            bottom: 0
            width: 100%
            height:1.3rem
            padding: .2rem
            background:rgba(0,0,0,.6)
            p
                font-size: .24rem
                font-weight:bold
                color: #ffffff
                line-height: .36rem
    .card +.card
        margin-top: .3rem
.img-container,.video-container
    position: fixed;
    z-index: 2000;
    background: #000000;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    .num
        position: absolute;
        color: #fff;
        top: .6rem;
        left: 50%;
        transform: translateX(-50%)
        font-size: .36rem
    .swiper-item
        padding: 0 .3rem
        img    
            width: 100%
.video-container
    padding: 0 .3rem
    text-align: center;
    .video
        width: 100%
</style>
